export const TEAM_COLLECTION = "Team";

export const TEAM_MEMBERS = [
  {
    documentPath: `${TEAM_COLLECTION}/James Gerard`,
    id: "james-gerard",
    name: "James Gerard",
    phone: "+19022259634",
    role: "CFO",
    storageDirectory: "Photos/Team/james-gerard",
  },
  {
    documentPath: `${TEAM_COLLECTION}/Lauchlan Mcdonough`,
    id: "lauchlan-mcdonough",
    name: "Lauchlan Mcdonough",
    phone: "+19028300081",
    role: "CRO",
    storageDirectory: "Photos/Team/lauchlan-mcdonough",
  },
  {
    documentPath: `${TEAM_COLLECTION}/Jackson Bruce`,
    id: "jackson-bruce",
    name: "Jackson Bruce",
    phone: "+19025800434",
    role: "COO",
    storageDirectory: "Photos/Team/jackson-bruce",
  },
  {
    documentPath: `${TEAM_COLLECTION}/James Lawley`,
    id: "james-lawley",
    name: "James Lawley",
    phone: "+19022203224",
    role: "CMO",
    storageDirectory: "Photos/Team/james-lawley",
  },
  {
    documentPath: `${TEAM_COLLECTION}/Peter Gillham`,
    id: "peter-gillham",
    name: "Peter Gillham",
    phone: "+19024101647",
    role: "CEO",
    storageDirectory: "Photos/Team/peter-gillham",
  },
];
